import type { RefObject } from "react";
import { jumpTo } from "../../../../ui/navigation/jumpTarget";

/**
 * Jumps to this Thread's current step, where a failed step is run again with its inputs (OW-08): into view, with
 * keyboard focus and a brief mark (F164). `currentStep` is the Thread view's own (`ThreadContext`), so a Thread in
 * another tab keeps its place (ADR-0039).
 */
export function showCurrentStep(currentStep: RefObject<HTMLElement | null>): void {
  const step = currentStep.current;
  if (step !== null) jumpTo(step, "start");
}
